import { useState } from "react";
import SideBar from "../../Common/SideBar";
import { useSelector } from "react-redux";
import BreadCrumbsContainer from "../../Common/Breadcrumbs";
import { Outlet } from "react-router-dom";

const PurchaseScreen = () => {
  const sidebar = useSelector(state => state.sidebar);

  return (
    <div className="dashboardOuterContainer">
      {/* <SideBar /> */}
      <div
        className={`${
          sidebar.expand
            ? "dashboardInnerSidebarBig"
            : "dashboardInnerSidebarSmall"
        }`}>
        <BreadCrumbsContainer />
        <div className="dashboardDataCardContainer overflow-x-hidden">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default PurchaseScreen;
